/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
import VPagination from "@hennge/vue3-pagination";

export default {
  name: "setTestVersionModal",
  components: {
    customModal,
    VPagination,
  },
  props: {
    showSetVersion: {
      type: Boolean,
      default: false,
    },
    labCode: {
      type: String,
      default: "",
    },
    testCode: {
      type: String,
      default: "",
    },
    currentVersion: {
       type: String,
      default: "",
    },
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      token: "",
      showLoading: false,
      versionList: [],
      totalPages: 0,
       gender: "",
        ageMin: null,
      ageMax: null,
      minRange: "",
      maxRange: "",
        localLabCode: "",
      localTestCode: "",
      ageErrors: [false, false, false],
      rangeErrors: [false, false],
      isEditing: false,
      editingId: null,
      currentPage: 1,
      localLabCode: "",
      localTestCode: "",
      versionNo: "",
      rangeSeverity: "",
      studyId: "",
      SortOrder: 0,
      SortProperty: "",
      currentPage: 1,
      unit: "",
      effectiveDate: new Date().toISOString().substring(0, 10),
      isActive: true,
      isEditing: false,
      editingId: null,
    };
  },
  async mounted() {
    this.token = store.getters.getIdToken;
    this.studyId = store.getters.getStudyIs;
    this.localLabCode = this.labCode;
    this.localTestCode = this.testCode;
  

    // Set default version number (increment)
    this.versionNo =   localStorage.getItem("newlyCreatedVersion");
    localStorage.removeItem("newlyCreatedVersion");
   
    await this.listVersions();
  },
  // watch: {
  //   currentVersion(newV) {
  //  this.versionNo = newV || "";
  //   },
  //   labCode(newVal) {
  //     this.localLabCode = newVal;
  //     this.listVersions();
  //   },
  //   testCode(newVal) {
  //     this.localTestCode = newVal;
  //     this.listVersions();
  //   },
  // },
  methods: {
    closeVersionModal() {
      this.resetForm();
      this.$emit("closeModal");
    },

    formatDate(dateStr) {
      if (!dateStr) return "";
      const d = new Date(dateStr);
      return d.toLocaleString();
    },
      closeSetVersion() {
      this.resetForm();
      this.$emit("closeModal");
    },

    async listVersions() {
      this.showLoading = true;
      try {
        const lab = this.localLabCode || this.labCode;
        const test = this.localTestCode || this.testCode;


        const response = await axios.get(
          `${this.baseurl}/management/labreferencerange/labreferencerangelist?LabCode=${lab}&TestCode=${test}&StudyId=${this.studyId}&VersionNo=${this.versionNo}&Gender=${this.gender}&pageindex=${this.currentPage}&pagesize=10&SortProperty=&SortOrder=0`,
          {
            headers: {
              Authorization: "Bearer " + this.token,
              "Content-Type": "application/json",
            },
          }
        );

        const data = response && response.data ? response.data : {};
        this.versionList = Array.isArray(data.results) ? data.results : [];
        this.totalPages = Math.ceil((data.totalCount || 0) / 10);
      } catch (err) {
        console.error("Error fetching versions:", err);
      } finally {
        this.showLoading = false;
      }
    },

    async saveVersion() {
      if (!this.versionNo || this.versionNo.toString().trim() === "") {
        alert(this.$t("navigations.please enter a version") || "Please enter a version number");
        return;
      }

      const payloadCommon = {
        LabCode: this.localLabCode || this.labCode,
        TestCode: this.localTestCode || this.testCode,
        VersionNo: this.versionNo,
        EffectiveDate: this.effectiveDate,
        IsActive: this.isActive,
           Unit: this.unit,
         Gender: this.gender,
        AgeMin: this.ageMin !== null && this.ageMin !== undefined ? this.ageMin : 0,
        AgeMax: this.ageMax !== null && this.ageMax !== undefined ? this.ageMax : 0,
        StudyId: store.getters.getStudyIs,
        AccountId: store.getters.getAccountId,
        CreatedUserId: store.getters.getUserId,
        CreatedUserEmail: store.getters.getUserEmail,
        CreatedAt: new Date().toISOString(),
        LastModifiedUserId: store.getters.getUserId,
        LastModifiedUserEmail: store.getters.getUserEmail,
        LastModifiedAt: new Date().toISOString(),
        Ranges: [],
      };

      try {
        if (this.isEditing && this.editingId) {
          const payload = { ...payloadCommon, Id: this.editingId };
          await axios.put(`${this.baseurl}/management/labreferencerange/update`, payload, {
            headers: {
              Authorization: "Bearer " + this.token,
              "Content-Type": "application/json",
            },
          });
          alert(this.$t("navigations.lab reference updated successfully") || "Version updated successfully");
        } else {
          await axios.post(`${this.baseurl}/management/labreferencerange/create`, payloadCommon, {
            headers: {
              Authorization: "Bearer " + this.token,
              "Content-Type": "application/json",
            },
          });
          alert(this.$t("navigations.lab reference created successfully") || "Version created successfully");
        }

        this.resetForm();
        await this.listVersions();
      } catch (err) {
        console.error("Save version error:", err);
        alert(err.response?.data?.detail || "Save operation failed");
      }
    },

    async editVersion(id) {
      try {
        const response = await axios.get(
          `${this.baseurl}/management/labreferencerange/getbyid?id=${id}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
          }
        );

        const record = response.data;
        if (record) {
          this.isEditing = true;
          this.editingId = record.id;

          this.gender = record.gender;
          this.ageMin = record.ageMin;
          this.ageMax = record.ageMax;
          this.minRange = record.ranges;
          this.maxRange = record.ranges;
          this.rangeSeverity = record.ranges;
          this.unit = record.unit;
          this.versionNo = record.versionNo;
          this.effectiveDate = record.effectiveDate;
          this.isActive = record.isActive;
          this.studyId = record.studyId;
           this.localLabCode = record.labCode;
          this.localTestCode = record.testCode;
          if (!this.showSetRange) this.$emit("openModal");
        }
      } catch (err) {
        console.error("Error fetching record by ID:", err);
        alert("Failed to load record for editing");
      }
    },

    async deleteVersion(id) {
      if (!confirm(this.$t("navigations.are you sure you want to delete this version?") || "Are you sure you want to delete this version?")) return;

      try {
        const response = await axios.delete(
          `${this.baseurl}/management/labreferencerange/deletebyid/?LabReferenceRangeID=${id}`,
          {
            headers: {
              Authorization: "Bearer " + this.token,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200 || response.status === 204) {
          alert(this.$t("navigations.version deleted successfully") || "Version deleted successfully");
          await this.listVersions();
        } else {
          alert("Delete may not have completed successfully");
        }
      } catch (err) {
        console.error("Delete version error:", err);
        alert(err.response?.data?.detail || "Delete failed");
      }
    },
    getVersionList() {
      return this.versionList;
    },

    resetForm() {
      this.isEditing = false;
      this.editingId = null;

      // Default increment logic again after editing

     this.gender = "";
      this.ageMin = null;
      this.ageMax = null;
      this.minRange = "";
      this.maxRange = "";
      this.rangeSeverity = "";
     
      
      this.effectiveDate = new Date().toISOString().substring(0, 10);
      this.isActive = true;
    },
  },
};
